/**
 * Feature-specific query keys for shops and categories
 * Co-located with the shop feature for better organization
 */

import type { ContractStatus, MerchantStatus, ShopStatus } from "@/openapi/generated";

export const shopQueryKeys = {
  all: ["shops"] as const,
  popular: (filters: { page?: number; size: number }) =>
    ["shops", "popular", filters] as const,
  byCategory: (params: { categoryId: string; page?: number; size: number }) =>
    ["shops", "byCategory", params] as const,
  search: (params: { term: string; page?: number; size: number; categoryId?: string }) =>
    ["shops", "search", params] as const,
  allShops: (params: { page?: number; size: number }) =>
    ["shops", "allShops", params] as const,
  withAssociations: (params: {
    page?: number;
    size?: number;
    name?: string;
    sort?: string[];
    status?: ShopStatus[];
    categoryId?: string;
    createdAtFrom?: string;
    createdAtTo?: string;
    updatedAtFrom?: string;
    updatedAtTo?: string;
    contractStatuses?: ContractStatus[];
    merchantStatuses?: MerchantStatus[];
    monetized?: boolean;
    uncategorized?: boolean;
  }) => ["shops", "withAssociations", params] as const,
  detail: (id: string) => ["shops", "detail", id] as const,
  detailBySlug: (slug: string) => ["shops", "detailBySlug", slug] as const,
  detailWithAssociations: (id: string) =>
    ["shops", "detailWithAssociations", id] as const,
  extensionConfig: (id: string) => ["shops", "extensionConfig", id] as const,
} as const;

